export default "__VITE_ASSET__Daer20A2__"